module.exports = __webpack_public_path__ + "static/media/b-sci-major-26_LR.8c1d6406.jpg";